<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Store
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.address"
                outlined
                label="Write your address here"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.address"
              >
              </v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.city"
                outlined
                label="City"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.city"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.state"
                outlined
                label="State"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.state"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pin_code"
                outlined
                label="Pin Code"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.pin_code"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file.value = null), (image_path = null)"
                >Remove</v-btn
              >

              <div id="preview" v-if="image_path" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img
                  :src="image_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                outlined
                v-model="form.is_verify"
                :items="verifyItem"
                label="Store Verify"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.is_verify"
              ></v-autocomplete>
            </v-col>
            <!-- <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col> -->
            <!-- /Start date -->
            <!-- <v-col sm="12">
              <label for="privacy-policy">Privacy Policy</label>
              <vue-editor
                ref="message"
                v-model="form.descriptions"
                class="form-control"
              />
            </v-col> -->
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Store
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "StoreIdPage",
  data() {
    return {
      form: {},
      isLoading: false,
       image_path: "",
      verifyItem: [
        { id: 1, text: "PENDING", value: 0 },
        { id: 2, text: "APPROVED", value: 1 },
      ],
      menu: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.storeId;
      axios
        .get(`/stores/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log("form", this.form);
          this.old_json = response.data.data;
          if (response.data.data.image_path) {
            this.image_path = this.mediaUrl + response.data.data.image_path;
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },

    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        let stores = await axios.patch(
          `/stores/${this.$route.params.storeId}`,
          this.form
        );
        this.stores = stores.data.data;
        await this.handleFileUpload();
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      if (this.$refs.file != null) {
        let attachment = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append("id", this.stores.id);
        formData.append("image_path", attachment);
        await axios
          .post("upload_stores_image", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch(function (error) {
            console.log(error);
            console.log("FAILURE!!");
          });
      }
    },
    onFileChange() {
      this.warningImageLoader = false;
      this.file = this.$refs.file?.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          this.imageLoader = false;
          this.image_path = URL.createObjectURL(this.file);
          this.imageErrors = "";
        };
        img.src = evt.target.result;
      };

      reader.onerror = (evt) => {
        console.error(evt);
      };
      // this.image_path = URL.createObjectURL(this.file);
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/stores/${this.form.id}`,
          from_name: "StoreIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/stores");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
